import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { UniversalDialogForRouter, } from 'console/dialogs/universal';
import { Outlet } from 'react-router';
import { useLocation } from 'react-router-dom';
import { MotionDiv } from 'shared/components/dialogs/router/styles';
export const RouterDialog = memo(function RouterDialog(props) {
    const { children, ...rest } = props;
    const { pathname } = useLocation();
    const sx = useCallback((theme) => ({
        '& .MuiAppBar-root': {
            backgroundColor: theme.palette.mode == 'dark'
                ? 'transparent'
                : theme.palette.primary.dark,
        },
    }), []);
    return (_jsx(ErrorBoundary, { children: _jsx(UniversalDialogForRouter, { maxWidth: "md", contentWithZeroPadding: true, sx: sx, ...rest, children: _jsxs(MotionDiv, { children: [children, _jsx(Outlet, {})] }, pathname) }) }));
});
